export default __webpack_public_path__ + "static/media/alphabet_white.89ce2cfc.svg";